import { AutoBalanceTransferTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchAutoBalanceTransferReport({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  const [autoBalanceReportTransactions, setAutoBalanceReportTransactions] =
    useState<AutoBalanceTransferTransaction[]>();

  async function fetchAutoBalanceTransferReport(transactionID: string) {
    try {
      setFetching(true);
      const res = await api.fetchAutoBalanceTransferReport({ TransactionID: transactionID }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setAutoBalanceReportTransactions(res.Transactions);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, autoBalanceReportTransactions, fetchAutoBalanceTransferReport };
}
